import { DASHBOARDS_LOADING, DASHBOARDS_LIST } from './MaintenanceActions';

const INITIAL_STATE = {
  dashboardsLoading: true,
  results: undefined,
  page: 0,
  total: 0,
};

const MaintenanceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DASHBOARDS_LOADING: {
      return { ...state, dashboardsLoading: action.payload || true };
    }
    case DASHBOARDS_LIST:
      return {
        ...state,
        dashboardsLoading: false,
        results: action.payload.results,
        page: action.payload.page,
        total: action.payload.total,
      };
    default:
      return { ...state };
  }
};

export default MaintenanceReducer;
